import React from 'react';
import { mergeClasses } from 'minimal-shared/utils';

import { Box } from '@/components/ui';

// ----------------------------------------------------------------------

type NavDropdownProps = React.ComponentProps<'div'> & {
  open: boolean;
  indicatorLeft?: number | null;
};

export const NavDropdown = ({
  open,
  indicatorLeft,
  children,
  className,
  ...other
}: NavDropdownProps) => (
  <Box
    className={mergeClasses([`absolute left-0 right-0 w-full z-40 top-[54px]`, className])}
    {...other}
  >
    <Box className={`${open ? 'mt-0 pt-8 px-6 block' : 'hidden'}`}>
      <Box className="relative overflow-hidden pt-[10px]">
        <Box className="z-10 bg-primary relative h-[4px] w-full rounded-full" />
        <Box
          className="absolute w-6 h-6 -bottom-[10px] bg-emerald-400 rounded-full shadow-md transition-all duration-300"
          style={{ left: `calc(${indicatorLeft}% - 12px) ` }}
        />
      </Box>
      <Box className="bg-white rounded-b-2xl shadow-lg p-6 transition-all duration-200 ease-in-out">
        {children}
      </Box>
    </Box>
  </Box>
);
